












































import {Component, Prop, Vue} from 'vue-property-decorator'
import {CombinedPlan} from "@/util/subscription";

@Component
export default class PricingTable extends Vue {

    @Prop({
        default: null
    })
    activePlanId!: number | null;

    @Prop()
    basicPlan!: CombinedPlan

    @Prop()
    proPlan!: CombinedPlan

    @Prop()
    premiumPlan!: CombinedPlan

    private activePricingOption: 'monthly' | 'yearly' = 'monthly';
}
